module.exports = __webpack_public_path__ + "static/media/pencil-square.a2edb7cf.svg";